export const normalizeNumericInput = (value: string): string =>
  value
    .replace(/[\uFF10-\uFF19\uFF0B\uFF0D\uFF0E\uFF25\uFF45]/g, (character) => character.normalize('NFKC'))
    .replace(/\u2212/g, '-');